export const UPDATE_SOURCE_PLAN = 'UPDATE_SOURCE_PLAN';
export const UPDATE_DESTINATION_PLAN = 'UPDATE_DESTINATION_PLAN';
export const PLANS_ASSIGN_RECEIVE_DESTINATION_PLANS =
  'PLANS_ASSIGN_RECEIVE_DESTINATION_PLANS';
export const PLANS_ASSIGN_RECEIVE_SOURCE_PLANS =
  'PLANS_ASSIGN_RECEIVE_SOURCE_PLANS';
export const PLANS_ASSIGN_PLANS_REQUEST_FAILED =
  'PLANS_ASSIGN_PLANS_REQUEST_FAILED';
